var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144.523,
    height: 136.191,
    viewBox: "0 0 144.523 136.191",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(-1831.699 -191.07)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5796",
    "data-name": "Group 5796",
    transform: "translate(1831.699 191.07)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5795",
    "data-name": "Group 5795"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6348",
    "data-name": "Path 6348",
    d: "M1935.966,230.671a8.7,8.7,0,0,0-1.18-3.405,45.518,45.518,0,0,0-4.747-6.1c-5.822-6.088-11.7-12.119-17.7-18.017-3.386-3.329-6.992-6.44-10.644-9.465a10.086,10.086,0,0,0-6.478-2.616q-21.4.057-42.8.019a21.31,21.31,0,0,0-8.3,1.75c-7.553,3.149-12.48,11.824-12.414,18.625.143,15.886.048,31.791.048,47.677,0,15.971-.038,31.933.019,47.9.019,6.792,3.187,12.128,8.447,16.181a19.5,19.5,0,0,0,12.357,4.043c5.774-.057,11.548-.009,17.322-.009q21.9,0,43.805,0c3.767.009,7.477-.19,10.9-2.007,7.153-3.776,11.5-9.389,11.51-17.76v-6.735c-.571.029-1.141.048-1.712.048a30.456,30.456,0,0,1-8.219-1.132c0,2.2-.01,4.385-.01,6.573a10.673,10.673,0,0,1-10.778,10.778q-31.277.086-62.573.01a10.572,10.572,0,0,1-10.673-10.8q-.029-23.643-.01-47.287h-.171c0-12.766-.019-25.541.01-38.316,0-2.92.114-5.841.162-8.761a10.611,10.611,0,0,1,10.511-10.559c6.925-.114,13.86-.1,20.785-.114q7.948-.029,15.9,0a4.58,4.58,0,0,1,4.747,3.643,10.563,10.563,0,0,1,.352,2.616c.076,2.235.047,4.48.1,6.725.1,4.48.19,8.961.333,13.441a4.945,4.945,0,0,0,5.213,5.051c5.365.124,10.73.219,16.1.323,1.294.019,2.578.038,3.872.019,3.082-.048,6.193,1.779,6.174,5.964,0,.9-.01,1.8-.01,2.7a30.242,30.242,0,0,1,8.19-1.122c.571,0,1.141.019,1.712.048v-5.66A27.765,27.765,0,0,0,1935.966,230.671Z",
    transform: "translate(-1831.699 -191.07)",
    fill: "#3067ae",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6349",
    "data-name": "Path 6349",
    d: "M1871.827,300.642c-8.556,0-3.793-.019-12.347.02a5.129,5.129,0,0,1-4.041-1.527,4.806,4.806,0,0,1-1.242-5.062,4.99,4.99,0,0,1,4.117-3.5,7.6,7.6,0,0,1,1.421-.073c16.908,0,25.252.015,42.159.021a5.834,5.834,0,0,1,4.016,1.136,4.935,4.935,0,0,1,1.708,5.472,5.793,5.793,0,0,1-4.758,3.558C1894.1,300.585,1880.586,300.641,1871.827,300.642Z",
    transform: "translate(-1832.783 -195.917)",
    fill: "#3067ae",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6350",
    "data-name": "Path 6350",
    d: "M1871.715,256.459c-7.4,0-1.483.017-8.883-.014a39.692,39.692,0,0,1-4.87-.307,4.715,4.715,0,0,1-4.026-5.053,5.034,5.034,0,0,1,4.511-4.711c.2-.012.406-.011.611-.011,17.379,0,26.2-.013,43.578.007,3.439,0,5.432,2.236,5.147,5.612a4.445,4.445,0,0,1-3.835,4.126,29.381,29.381,0,0,1-4.053.324c-7.808.03-20.371.014-28.178.014Z",
    transform: "translate(-1832.783 -193.765)",
    fill: "#3067ae",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6351",
    "data-name": "Path 6351",
    d: "M1866.733,278.4c-7.131,0-.944.023-8.075-.012a4.569,4.569,0,0,1-4.553-3.635,4.878,4.878,0,0,1,2.308-5.582,5.293,5.293,0,0,1,2.124-.563c2.982-.155,5.968-.3,8.953-.315,9.508-.032,10.454-.015,19.961.016,1.763.006,3.535.332,5.283.219,2.4-.156,4.682,2.224,4.614,5.171a4.884,4.884,0,0,1-4.877,4.718c-3.8-.146-12.36.01-16.163.023-3.191.011-6.384,0-9.575,0Z",
    transform: "translate(-1832.783 -194.834)",
    fill: "#3067ae",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5797",
    "data-name": "Group 5797",
    transform: "translate(1908.872 245.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6352",
    "data-name": "Path 6352",
    d: "M1934.651,248.929a24.267,24.267,0,1,1-21.7,26.567,24.284,24.284,0,0,1,21.7-26.567m18.761,22.5a16.4,16.4,0,1,0-14.648,17.96,16.4,16.4,0,0,0,14.648-17.96",
    transform: "translate(-1912.827 -248.803)",
    fill: "#3067ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6353",
    "data-name": "Path 6353",
    d: "M1956.344,294.6l5.6-6.9c.4.281.948.665,1.494,1.058q8.6,6.208,17.2,12.418c1.961,1.418,2.188,3.2.662,5.087-1.023,1.268-2.037,2.545-3.082,3.794a3.044,3.044,0,0,1-4.5.4q-8.69-7.876-17.333-15.8c-.046-.042-.072-.1-.039-.054",
    transform: "translate(-1914.948 -250.699)",
    fill: "#3067ae"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsIcon);
export default __webpack_public_path__ + "static/media/details-icon.5d95e6ef4570104de4c259e152de4aa6.svg";
export { ForwardRef as ReactComponent };